<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="320">
        <v-card width="780px">
            <v-card-title style="background: #455a64; color: white">
                <span class="overline font-weight-black">仕様検討ツール</span>
            </v-card-title>
                <v-card-text>
                    <div>
                        <v-radio-group  hide-details row v-model="shioRequestSelection" class="ml-2">
                            <!-- NOTE - ORIGINAL CODE 11/18/25 -->
                            <!-- <v-radio label="仕様検討ツール作成依頼" value="0"></v-radio>  -->

                            <!-- NOTE - NEW CONDITION - WILL NOT SHOW IF HOUSE TYPE IS HUGME AND HUGME FAM SINCE SRS DATA IS REQUIRED FOR THESE HOUSETYPE -->
                           <!-- <v-radio :disabled="$store.state.hokkaidou.includes(cadRequestBasicInformation.house_type_id)"  label="仕様検討ツール作成依頼" value="0"></v-radio> -->

                            <v-radio :disabled="$store.state.hokkaidou.some(h => h.id === cadRequestBasicInformation.house_type_id && h.hokkaidou == '2')" label="仕様検討ツール作成依頼" value="0"></v-radio>
                            <!-- <v-radio :disabled="!$store.state.hokkaidou.some(h => h.id === cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || cadRequestBasicInformation.site_address_prefecture_code === '01'))" @click="checkSrsData()" label="仕様書依頼システム(SRS)より依頼" value="1"></v-radio> -->
                            
                            <!-- NOTE - CODED - 20260623 -->
                            <!-- <v-radio :disabled="!$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner != 1)" @click="checkSrsData()" label="仕様書依頼システム(SRS)より依頼" value="1"></v-radio> -->
                            
                            <!-- NOTE - CODED - 20260624 - BY UARY -->
                            <!-- <v-radio :disabled="isSrsButtonDisabled" @click="checkSrsData()" label="仕様書依頼システム(SRS)より依頼" value="1"></v-radio> -->
                            <!-- <v-radio :disabled="cadRequestBasicInformation.house_type_id != 3 && cadRequestBasicInformation.house_type_id != 29" @click="openSRS()" label="仕様書依頼システム(SRS)より依頼" value="1"></v-radio> -->
                            <!-- <v-radio :disabled="!$store.state.hokkaidou.includes(cadRequestBasicInformation.house_type_id)" @click="openSRS()" label="仕様書依頼システム(SRS)より依頼" value="1"></v-radio> -->
                            <!-- <v-radio :disabled="!(($store.state.loggedInUser.isHokkaidou_planner == 1 && $store.state.HOUSE_TYPES.some(h => h.id === cadRequestBasicInformation.house_type_id && h.house_type_category_id == '2')) || ($store.state.loggedInUser.isHokkaidou_planner != 1 && $store.state.HOUSE_TYPES.some(h => h.id === cadRequestBasicInformation.house_type_id && h.hokkaidou == '2')) || ($store.state.loggedInUser.isHokkaidou_planner != 1 && $store.state.loggedInUser.can_use_srs != null))" @click="checkSrsData()" label="SRSより依頼" value="1"></v-radio> -->
                            <v-radio :disabled="!(($store.state.loggedInUser.isHokkaidou_planner == 1 && $store.state.HOUSE_TYPES.some(h => h.id === cadRequestBasicInformation.house_type_id && h.house_type_category_id == '2')) || ($store.state.loggedInUser.isHokkaidou_planner != 1 && $store.state.HOUSE_TYPES.some(h => h.id === cadRequestBasicInformation.house_type_id && h.hokkaidou == '2')) || ($store.state.loggedInUser.isHokkaidou_planner != 1 && $store.state.loggedInUser.can_use_srs != null && (cadRequestBasicInformation.house_type_id == 35 || cadRequestBasicInformation.house_type_id == 36 || cadRequestBasicInformation.house_type_id == 38 || cadRequestBasicInformation.house_type_id == 39)))" @click="checkSrsData()" label="SRSより依頼" value="1"></v-radio>
                            
                            <v-radio v-if="$store.state.getRadio == '8' && $store.state.isHrdCpn == 1" label="カラー立面図の補正 (PEL only)" value="2"></v-radio>
                            <v-radio :disabled="!(($store.state.loggedInUser.isHokkaidou_planner == 1 && $store.state.HOUSE_TYPES.some(h => h.id === cadRequestBasicInformation.house_type_id && h.house_type_category_id == '2'))) || $store.state.hokkaidou.some(h => h.id === cadRequestBasicInformation.house_type_id && h.hokkaidou == '2' || ($store.state.loggedInUser.isHokkaidou_planner != 1  ))" label="SRS+ 「設備シート依頼用入力シート」 より依頼" value="3"></v-radio>
                        </v-radio-group>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="red" @click="cancelNewSubmit">キャンセル</v-btn>
                    <v-btn v-if="shioRequestSelection" dark color="green" @click="submitShioRequest">保存</v-btn>
                </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2';
export default {
    props: {
        dialog: Boolean
    },

    data(){
        return {
            shioRequestSelection: null,
            SRS_shio: {
                shio_selection: null,
                shio_number: null,
            },
            srsNumber: null,
            env: {
				response : process.env.MIX_ENV == 'local' ? 'response-local' : 'response',
				request : process.env.MIX_ENV == 'local' ? 'request-local' : 'request',
			},
            customer_code: null,
            revision_number: null,
        }
    },

        sockets: {
        // NOTE : SOCKET 
        updateReceived: async function(socket) {
            

        }
    },

    computed: {
        isSrsButtonDisabled() {
            const user = this.$store.state.loggedInUser;
            const hokkaidouList = this.$store.state.hokkaidou;
            const houseTypeId = this.cadRequestBasicInformation.house_type_id;

            if (user.isHokkaidou_planner != 1) return true;

            const hasValidRegion = hokkaidouList.some(h => 
                h.id === houseTypeId && (h.hokkaidou == '2' || h.hokkaidou == '1')
            );

            return !hasValidRegion;
        },
        ...mapState([
            'loggedInUser',
            'cadRequestBasicInformation',
            'cadRequestRevisionContent',
            'editCadRequestRevisionContent',
            'editMode',
        ])
    },
    

    methods: {
        openSRS(){
            let key = process.env.MIX_API_KEY;
            const randomNum = Math.random() * 9000
            const formattedRandomNum = Math.floor(randomNum)
            this.srsNumber = formattedRandomNum;
            // window.open(`http://10.169.141.136:4000/acceptredirect/${this.loggedInUser.email}/${this.loggedInUser.name}/${this.cadRequestBasicInformation.customer_code}/${this.revision_number}/${this.cadRequestBasicInformation.house_type_id}/${key}/${formattedRandomNum}`, 'blank');
            // // window.open(`http://ec2-54-254-226-185.ap-southeast-1.compute.amazonaws.com/acceptredirect/${this.loggedInUser.email}/${this.loggedInUser.name}/${this.cadRequestBasicInformation.customer_code}/${this.revision_number}/${this.cadRequestBasicInformation.house_type_id}/${key}/${formattedRandomNum}`, 'blank');
            
            // window.open(`https://srs-test.ihs-w.com/acceptredirect/${this.loggedInUser.email}/${this.loggedInUser.name}/${this.cadRequestBasicInformation.customer_code}/${this.revision_number}/${this.cadRequestBasicInformation.house_type_id}/${key}/${formattedRandomNum}`, 'blank');
            // // window.open(`http://ec2-54-254-226-185.ap-southeast-1.compute.amazonaws.com/acceptredirect/${this.loggedInUser.email}/${this.loggedInUser.name}/${this.cadRequestBasicInformation.customer_code}/${this.revision_number}/${this.cadRequestBasicInformation.house_type_id}/${key}/${formattedRandomNum}`, 'blank');
            
            // comment ni uary090825
            window.open(`https://srs.hrd-s.com/acceptredirect/${this.loggedInUser.email}/${this.loggedInUser.name}/${this.cadRequestBasicInformation.customer_code}/${this.revision_number}/${this.cadRequestBasicInformation.house_type_id}/${key}/${formattedRandomNum}`, 'blank');
            // window.open(`http://ec2-54-254-226-185.ap-southeast-1.compute.amazonaws.com/acceptredirect/${this.loggedInUser.email}/${this.loggedInUser.name}/${this.cadRequestBasicInformation.customer_code}/${this.revision_number}/${this.cadRequestBasicInformation.house_type_id}/${key}/${formattedRandomNum}`, 'blank');
        },

        checkSrsData(){
            if(this.shioRequestSelection){
                if(this.shioRequestSelection == '1'){
                    try {
                        this.$socket.emit('newUpdate', {
                        dispatchType: this.env.request,
                        data: {
                            customerCode: this.cadRequestBasicInformation.customer_code,
                            revision_number: this.revision_number,
                            uniqId: this.loggedInUser.uniqId
                        },
                        functionType: 'srsLatest'
                        });
                    } catch (error) {
                        console.log(error, 'socket error');
                    }
                }
                this.SRS_shio.shio_selection = this.shioRequestSelection
                
                
            }
        },

        submitShioRequest(){
            // console.log(this.$store.state.loggedInUser.can_use_srs);
            
            if(this.shioRequestSelection){
                if(this.shioRequestSelection == '1'){
                    try {
                        this.$socket.emit('newUpdate', {
                        dispatchType: this.env.request,
                        data: {
                            customerCode: this.cadRequestBasicInformation.customer_code,
                            revision_number: this.revision_number,
                            uniqId: this.loggedInUser.uniqId
                        },
                        functionType: 'srsLatest'
                        });
                    } catch (error) {
                        console.log(error, 'socket error');
                    }
                }
                this.SRS_shio.shio_selection = this.shioRequestSelection
                this.$emit('submitShioRequest', this.SRS_shio)
                this. toggleDialogShioRequest(false)
            }
        },


        // NOTE - MODIFIED 11-24-25
        // submitShioRequest(){
            
        //         if(this.shioRequestSelection){
        //             if(this.shioRequestSelection == '1'){
        //                 try {
        //                     this.$socket.emit('newUpdate', {
        //                     dispatchType: this.env.request,
        //                     data: {
        //                         customerCode: this.cadRequestBasicInformation.customer_code,
        //                         revision_number: this.revision_number,
        //                         uniqId: this.loggedInUser.uniqId
        //                     },
        //                     functionType: 'srsLatest'
        //                     });
        //                     // console.log(this.cadRequestBasicInformation.customer_code)
        //                     // console.log(this.revision_number)
        //                     // console.log(this.loggedInUser.uniqId)
        //                 } catch (error) {
        //                     console.log(error, 'socket error');
        //                 }
        //                 setTimeout(() => {
        //                     if(this.$store.state.cadRequestRevisionContent.SRS_request.shio_number == 1){
        //                         this.$emit('submitShioRequest', this.SRS_shio)
        //                         this. toggleDialogShioRequest(false)
        //                     }else{
        //                         this.SRS_shio = {
        //                             shio_selection: null,
        //                             shio_number: null,
        //                         }
        //                         Swal.fire({
        //                             html: '<div style="text-align: left;font-size:22px;font-weight:bold;">' +
        //                                 '仕様検討ツールが未作成・保存の為、CAD依頼送信ができません。.<br>' +
        //                                 'SRSにて作成保存してください。.<br><br>' +
        //                                 'CAD request cannot be sent because Shiyo request has not been created or saved. .<br><br>' +
        //                                 'Please create and save it in SRS.',
        //                             icon: 'warning',
        //                             width : 630,
        //                         });
        //                         this. toggleDialogShioRequest(false)
        //                     }
        //                 },300)
        //                 // console.log(this.$store.state.cadRequestRevisionContent.SRS_request.shio_number, 'testing')
        //             }else{
        //                 this.$emit('submitShioRequest', this.SRS_shio)
        //                 this. toggleDialogShioRequest(false)
        //             }
                    
        //             // console.log(this.SRS_shio)
        //             // this.SRS_shio.shio_selection = this.shioRequestSelection
        //             // console.log(this.SRS_shio.shio_number, 'shiyoo')

        //             // setTimeout(function(){
        //             //     if(this.SRS_shio.shio_number == null){
        //             //         alert('oooops walang laman')
        //             //         return;
        //             //     }else{
        //             //         this.$emit('submitShioRequest', this.SRS_shio)
        //             //         this. toggleDialogShioRequest(false)
        //             //     }
        //             // },300)
                    
                    

                    
        //             // // if(this.SRS_shio.shio_number == null){
                        
        //             // //     // return;
        //             // // }else{
                        
        //             // // }
                    


        //             // this.$emit('submitShioRequest', this.SRS_shio)
        //             // this. toggleDialogShioRequest(false)
                    
        //         }
            

        // },

        cancelNewSubmit(){
            this.SRS_shio = {
                shio_selection: null,
                shio_number: null,
            }
            // this.$emit('submitShioRequest', this.SRS_shio)
            if(!this.$store.state.editMode) {
                if(this.$store.state.loggedInUser.isHokkaidou_planner == 1){
                    this. toggleDialogShioRequest(false)
                }else{
                    this.$store.state.cadRequestRevisionContent.shio_request = null;
                }
                
            }
            // else this.$store.state.editCadRequestRevisionContent.shio_request = null;
            this.toggleDialogShioRequest(false);
        },

        toggleDialogShioRequest(value){
            this.$emit('toggleDialogShioRequest', value)
        },
    },

    watch: {
        dialog(val){
            if(val){
                if(this.$store.state.editMode){
                    this.revision_number = this.$store.state.editCadRequestRevisionContent.revision_number

                    if(this.$store.state.editCadRequestRevisionContent.SRS_request){
                        this.shioRequestSelection = this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection
                    }
                }else{
                    this.revision_number = this.$store.state.cadRequestRevisionContent.revision
                    if(this.$store.state.cadRequestRevisionContent.SRS_request){
                        this.shioRequestSelection = this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection
                    }
                }
            }
        },
        "$store.state.editCadRequestRevisionContent"(val){
            // console.log(val.SRS_request.shio_selection,'shiorequest')
        }
    }
}
</script>

<style>

</style>
